
import { ConfigurationStore } from '@/store/modules';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { ValidationObserver } from 'vee-validate';
import { Component, Vue } from 'vue-property-decorator';
import { SMTPSetting } from '@/store/models/configuration';

@Component({
  meta: {
    title: 'SMTP Settings'
  },
  components: {
    QvInput,
    QvSelect,
    ValidationObserver
  }
})
export default class SMTPSettings extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
    testEmailObserver: InstanceType<typeof ValidationObserver>;
  };
  isPwd = true;
  email = '';

  get oldSmtpSettings() {
    return ConfigurationStore.OldSMTPSettings;
  }

  get smtpSettings() {
    return ConfigurationStore.SMTPSettings;
  }

  set smtpSettings(smtpSetting: SMTPSetting) {
    ConfigurationStore.setSMTPSettings(smtpSetting);
  }

  async onSubmit() {
    this.smtpSettings.hostUser = this.smtpSettings.hostUser.toLowerCase();
    // eslint-disable-next-line
    await ConfigurationStore.updateSMTPSettings(this.smtpSettings);
    this.$q.notify({
      type: 'positive',
      message: `Settings updated successful`,
      timeout: 5000
    });
  }

  async updateAndSendEmail() {
    const isValid = await this.$refs.observer.validate();
    if (isValid) {
      await ConfigurationStore.updateSMTPSettings(this.smtpSettings);
      const response = await ConfigurationStore.testSMTPSetting({
        email: this.email.toLowerCase()
      });
      this.$q.notify({
        type: 'positive',
        message: response.message,
        timeout: 5000
      });
    }
  }

  async onReset() {
    this.smtpSettings = this.oldSmtpSettings;
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
      this.$refs.testEmailObserver.reset();
      this.$router.push({ name: 'Settings' });
    });
  }

  async created() {
    await ConfigurationStore.getSMTPSettings();
  }
}
